import React, { useRef } from 'react';
import styled from 'styled-components';
import { useChartHelper, Style as ChartStyle } from '../../../../screens/Analysis/sca-dds-kyc-widgets/progress-per-time/helper';

const Style = styled.div`
  margin-top: 36px;

  .widgets {
    display: flex;
    margin-top: 30px;
    flex-wrap: wrap;
    gap: 10px;

    .main {
      flex: 1;
      min-width: 200px;
    }
  }
`;

const chartStyle = { height: 170, width: 'calc(100% - 48px)', marginLeft: 'auto', marginRight: 'auto', }

const InformationAvailability = ({
  t = (s) => s,
  completion = [],
}) => {
  const ref = useRef();

  useChartHelper({
    type: 'SCP_PROJECT',
    ref,
    publishments: completion,
    isConsolidated: false,
    customYAxis: [0, 25, 50, 75, 100],
  }, t);

  return (
    <Style>
      <h3 className="w-p">{t('Information Availability')}</h3>
      <div className="widgets">
        <div className="main">
          <ChartStyle ref={ref} style={chartStyle} />
        </div>
      </div>
    </Style>
  );
};

export default InformationAvailability;
